// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"website-module--mainSection--schOg"};